export const CONTACT_STATUS = {
  pendente: ["A contatar", "border-slate-500/40 bg-slate-500/15 text-slate-200"],
  tentativa: ["Tentativa feita", "border-sky-500/40 bg-sky-500/15 text-sky-200"],
  confirmado: ["Agendamento confirmado", "border-emerald-500/40 bg-emerald-500/15 text-emerald-200"],
  recusou: ["Não quer agora", "border-rose-500/40 bg-rose-500/15 text-rose-200"],
  adiado: ["Contato adiado", "border-amber-500/40 bg-amber-500/15 text-amber-200"],
};

export const MESSAGE_STATUS = {
  preparada: ["Preparada (não enviada)", "text-slate-300"],
  pendente: ["Na fila", "text-slate-300"],
  enviando: ["Enviando", "text-sky-300"],
  enviada: ["Enviada", "text-emerald-300"],
  entregue: ["Entregue", "text-emerald-300"],
  lida: ["Lida pelo cliente", "text-emerald-200"],
  confirmada: ["Confirmada pelo cliente", "text-emerald-200"],
  falhou: ["Falhou", "text-rose-300"],
  "aberta no WhatsApp": ["Aberta no WhatsApp (envio manual)", "text-emerald-200"],
  copiada: ["Copiada (envio manual)", "text-slate-200"],
};

export const ContactBadge = ({ status, testid }) => {
  const [label, cls] = CONTACT_STATUS[status] || CONTACT_STATUS.pendente;
  return <span className={`rounded-full border px-2 py-0.5 text-[11px] font-semibold ${cls}`} data-testid={testid}>{label}</span>;
};
